import { BaseApiService, apiClient } from 'shared/api/client';

export class ClientService extends BaseApiService {
    constructor() {
        super('/parties/admin-api/clients');
    }

    async sendNotification(queryString, token, template_id) {
        return apiClient.post(`${this.endpoint}/send-notification/${queryString}/`, { template_id }, token);
    }
}

export const clientService = new ClientService();
